'use client';

import CommonMenu from '@/components/layouts/CommonMenu/CommonMenu';
import { signOut, useSession } from 'next-auth/react';
import React from 'react';
import { postSignout } from '../../api/postSignout';

function MenuWrapper({
  isOptionNotEntered = false,
  hasPendingEntry = false,
}: {
  isOptionNotEntered?: boolean;
  hasPendingEntry?: boolean;
}) {
  const session = useSession();

  const user = session.data?.user;

  const logout = async () => {
    try {
      await postSignout();
    } catch {
    } finally {
      // 仮にエラーが起きてても強制ログアウト
      signOut();
    }
  };

  return (
    <>
      <CommonMenu
        onLogout={logout}
        userCoin={user?.coin}
        userName={user?.name}
        userUnreadMessageBoxCount={user?.unreadMessageBoxCount}
        isOptionNotEntered={isOptionNotEntered}
        hasPendingEntry={hasPendingEntry}
      />
    </>
  );
}

export default MenuWrapper;
